import { useNavigate } from "react-router-dom";
import ConvertDate from "../../common/ConvertDate";
import { toast } from "react-toastify";

const TourItem = ({ tourItem, index }) => {
  const navigate = useNavigate();
  const editHandler = (id, PackageType, title, packageNumber) => {
    if (PackageType === 1) {
      navigate(
        `/manageTours/${id}?title=${title}&packageNumber=${packageNumber}`
      );
    } else {
      toast.error("امکان ویرایش این تور وجود ندارد.");
    }
  };

  return (
    <div className="flex flex-wrap md:flex-nowrap justify-between gap-y-1 md:gap-x-1 lg:gap-x-0 my-4 mx-4">
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        }  text-slate-700 w-[49.5%] md:w-[12%] p-2 md:px-1 md:py-3 hidden md:flex md:flex-row items-center justify-center rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          نوع تور
        </div>
        <div className="text-sm font-bold text-slate-800 md:text-xs">
          {tourItem.PackageType === 0 ? (
            <span>هوایی</span>
          ) : tourItem.PackageType === 1 ? (
            <span>طبیعت‌گردی</span>
          ) : tourItem.PackageType === 2 ? (
            <span>زمینی</span>
          ) : (
            <span>-</span>
          )}
        </div>
      </div>
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        } text-slate-700 w-[100%] md:w-[30%] p-2 md:px-1 flex flex-col md:flex-row items-start
         justify-start md:justify-start rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          عنوان تور
        </div>
        <div className="flex items-center gap-2 text-sm font-bold text-slate-800 md:text-xs">
          {tourItem.PageURL && tourItem.CityUrl ? (
            <a
              className=""
              href={`https://kite.ir/tours/${tourItem.CityUrl.replaceAll(
                " ",
                "-"
              )}/${tourItem.PageURL}`}
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          ) : (
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </span>
          )}
          {tourItem.Title}
        </div>
      </div>
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        } text-slate-700 w-[49.5%] md:w-[12%] p-2 md:px-1 flex flex-col md:flex-row items-center justify-center rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          شماره تور
        </div>
        <div className="text-sm font-bold text-slate-800 md:text-xs">
          {tourItem.PackageNumber}
        </div>
      </div>
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        } text-slate-700 w-[49.5%] md:w-[11%] p-2 md:px-1 flex flex-col md:flex-row items-center justify-center rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          تاریخ ثبت تور
        </div>
        <div className="text-sm font-bold text-slate-800 md:text-xs">
          {ConvertDate(tourItem.PackageDate.slice(6, 19))}
        </div>
      </div>
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        } text-slate-700 w-[49.5%] md:w-[16%] p-2 md:px-1 flex flex-col md:flex-row items-center justify-center rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          اعتبار پکیج
        </div>
        <div className="text-sm flex flex-col lg:flex-row font-bold text-slate-800 md:text-xs">
          <span className="md:block">
            {ConvertDate(tourItem.StartDate.slice(6, 19))}
          </span>
          &nbsp;-&nbsp;
          <span className="md:block">
            {ConvertDate(tourItem.FinishDate.slice(6, 19))}
          </span>
        </div>
      </div>
      <div
        className={`${
          tourItem.State === 0 ? "bg-gray-100" : "bg-red-100"
        } text-slate-700 w-[49.5%] md:w-[12%] p-2 md:px-1 flex flex-col md:flex-row items-center justify-center rounded-sm`}
      >
        <div className="text-sm font-semibold text-slate-500 mb-1 md:hidden">
          وضعیت
        </div>
        <div className="text-sm font-bold text-slate-700 md:text-xs">
          {tourItem.State === 0 ? "فعال" : "غیر فعال"}
        </div>
      </div>
      <button
        className={`bg-lightGreenKite ${
          tourItem.State === 0 ? "md:bg-gray-100" : "md:bg-red-100"
        }  md:text-slate-700 text-white w-full md:w-[7%] text-sm md:text-xs p-2 flex items-center justify-center rounded-sm`}
        onClick={() =>
          editHandler(
            tourItem.Id,
            tourItem.PackageType,
            tourItem.Title,
            tourItem.PackageNumber
          )
        }
      >
        ویرایش
      </button>
    </div>
  );
};

export default TourItem;
